import store from '@/store'
import router from '@/router'
import apiPath from '@config/api.json' // 引入api.json文件
import hostPath from '@config/host'
import CryptoJS from 'crypto-js' // 加密
const $ = require('jquery')
const axios = require('axios')
const { Message, Loading, MessageBox } = require('element-ui')
const regionData = require('@root/static/js/region')
export default {
  // 所有输入框限制仅为英文和数字
  limitInputChinese (val) {
    // return val.replace(/[\u4E00-\u9FA5]/g, '') 可以输入字符
    return val.replace(/[^\w\\/]/gi, '')
  },
  //  密码长度6位以上，须包含大写、小写、数字、特殊符号中的任意3种
  testPassWord (str) {
    var rC = {
      lW: '[a-z]',
      uW: '[A-Z]',
      nW: '[0-9]',
      sW: '[\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E]'
    }

    function Reg (str, rStr) {
      var reg = new RegExp(rStr)
      if (reg.test(str)) {
        return true
      } else {
        return false
      }
    }

    if (str.length < 8) {
      if (this.isEnLan()) {
        return this.warningInfoTip('Your password is too short')
      } else {
        return this.warningInfoTip('密码至少8位')
      }
    } else {
      var tR = {
        l: Reg(str, rC.lW),
        u: Reg(str, rC.uW),
        n: Reg(str, rC.nW),
        s: Reg(str, rC.sW)
      }
      if (
        (tR.l && tR.u && tR.n) ||
        (tR.l && tR.u && tR.s) ||
        (tR.s && tR.u && tR.n) ||
        (tR.s && tR.l && tR.n)
      ) {
        return true
      } else {
        if (this.isEnLan()) {
          return this.warningInfoTip(
            "Your password must contain any three of 'lowercase letters', 'uppercase letters', 'numbers', 'special characters'"
          )
        } else {
          return this.warningInfoTip(
            "密码至少包含其中3个 '小写字母', '大写字母', '数字', '符号'"
          )
        }
      }
    }
  },

  // 限制只能输入数字(不能输入小数点)
  limitInputNumber (val) {
    return val.replace(/\D/g, '')
  },
  // 限制只能输入数字,和两位小数
  limitInputNumberDot (val) {
    let value = null
    value = this.ToCDB(val)
    // value = value.replace(/\D/g, '')
    value = value.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
    value = value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
    value = value
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    return value
  },
  // 只能 电话号码 0到9 和-
  limitPhoneNumber (val) {
    let value = val
    value = value.replace(/[^0-9()-]/g, '')
    // console.log(value)
    return value
  },

  // 只能 号码和英文和字符
  limitNumberleter (val) {
    let value = val
    value = value.replace(/[^0-9a-zA-Z@._-]/g, '')
    // console.log(value)
    return value
  },

  // 全角转半角
  ToCDB (str) {
    var result = ''
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) === 12288) {
        result += String.fromCharCode(str.charCodeAt(i) - 12256)
        continue
      }
      if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
        result += String.fromCharCode(str.charCodeAt(i) - 65248)
      } else {
        result += String.fromCharCode(str.charCodeAt(i))
      }
    }
    return result
  },
  // 设置cookie
  setCookie: function (name, value) {
    let getValue = this.getCookie
    if (getValue !== null && getValue !== '') {
      this.delCookie(name)
    }
    let exdate = new Date()
    let expiredays = 60
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie =
      name +
      '=' +
      escape(value) +
      (expiredays === null
        ? ''
        : ';expires=' + exdate.toGMTString() + ';path=/')
  },

  // 获得cookie
  getCookie: function (name) {
    if (document.cookie.length > 0) {
      let cStart = document.cookie.indexOf(name + '=')
      if (cStart !== -1) {
        cStart = cStart + name.length + 1
        let cEnd = document.cookie.indexOf(';', cStart)
        if (cEnd === -1) cEnd = document.cookie.length
        return unescape(document.cookie.substring(cStart, cEnd))
      }
    }
    return ''
  },

  // 删除cookie
  delCookie: function (name) {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.getCookie(name)
    if (cval !== null) {
      document.cookie =
        name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/'
    }
  },

  // 设置localStorage
  setLocalStorage (name, value) {
    localStorage.setItem(name, value)
  },

  // 读取localStorage
  getLocalStorage (name) {
    const item = localStorage.getItem(name)
    return item
  },

  // 删除localStorage
  delLocalStorage (name) {
    localStorage.removeItem(name)
  },

  // 登录后保存登录信息
  setLoginInfo (
    token,
    userId,
    userImg,
    userName,
    sysType,
    platformNo,
    agentNo,
    platform,
    agent,
    channelNo,
    lastLoginDate,
    platformHost,
    permissionNo,
    dtcOrgUser
  ) {
    // this.setCookie('dtcTk', token) // 登录的token
    // this.setCookie('dtcUId', userId) // 用户Id
    this.setCookie('dtcUImg', userImg) // 用户头像
    this.setCookie('dtcUName', userName) // 用户昵称
    this.setCookie('dtcUSysType', sysType) //  用户权限，0：GLS，1：平台，2：代理商 3、渠道商
    this.setCookie('dtcPlatformNo', platformNo) //
    this.setCookie('dtcAgentNo', agentNo) // 推荐代理商编号
    this.setCookie('dtcPlatform', platform) // platform
    this.setCookie('dtcAgent', agent) // agent
    this.setCookie('dtcChannelNo', channelNo) // 渠道商编号
    this.setCookie('dtcPlatformHost', platformHost) // 代理商二维码地址
    this.setCookie('dtcLastLoginDate', lastLoginDate) // 上一次登录时间
    this.setCookie('dtcPermissionNo', permissionNo) // 推荐编号
    this.setCookie('dtcOrgUser', dtcOrgUser) // 机构角色 0既不是机构也不是合作伙伴 1 机构 2既是机构也是合作伙伴
  },

  // 清除登录的信息
  clearLoginInfo () {
    this.delCookie('dtcTk')
    this.delCookie('dtcUId')
    this.delCookie('dtcUImg')
    this.delCookie('dtcUName')
    this.delCookie('dtcOneMenuId')
    this.delCookie('dtcTwoMenuId')
    this.delCookie('dtcUSysType')
    this.delCookie('dtcPlatformNo')
    this.delCookie('dtcAgentNo')
    this.delCookie('dtcPlatform')
    this.delCookie('dtcAgent')
    this.delCookie('dtcChannelNo')
    this.delCookie('dtcLastLoginDate')
    this.delCookie('dtcPlatformHost')
    this.delLocalStorage('dtcListMenu')
    this.delLocalStorage('dtcNewRoute')
    // this.delCookie('dtcNewRoute')
    this.delCookie('dtcPermissionNo')
    this.delCookie('dtcOrgUser')
  },
  getOrgUser () {
    const o = this.getCookie('dtcOrgUser')
    return o
  },
  // 获得登录的时间
  getLastLoginDate () {
    let t = this.getCookie('dtcLastLoginDate')
    return t
  },
  // 登录的token
  setToken (v) {
    this.setCookie('dtcTk', v)
  },
  getToken () {
    let t = this.getCookie('dtcTk')
    return t
  },

  // 获得登录的用户Id
  setUserId (v) {
    this.setCookie('dtcUId', v)
  },
  getUserId () {
    let i = this.getCookie('dtcUId')
    return i
  },

  // 获得登录的用户头像
  getUserImg () {
    let i = this.getCookie('dtcUImg')
    return i
  },

  // 获得平台商编号
  getPlatformNo () {
    let i = this.getCookie('dtcPlatformNo')
    return i
  },
  // 获得机构编码
  getAgentNo () {
    let i = this.getCookie('dtcAgentNo')
    return i
  },
  // 获取渠道商编号
  getChannelNo () {
    let i = this.getCookie('dtcChannelNo')
    return i
  },
  // 获得Platform
  getPlatform () {
    let i = this.getCookie('dtcPlatform')
    return i
  },
  // 获得PlatformHost
  getPlatformHost () {
    let i = this.getCookie('dtcPlatformHost')
    return i
  },
  // 获得dtcAgent
  getAgent () {
    let i = this.getCookie('dtcAgent')
    return i
  },

  // 获得登录的用户名字
  getUserName () {
    let n = this.getCookie('dtcUName')
    return n
  },

  // 设置一级菜单ID
  setOneMenuId (i) {
    this.setCookie('dtcOneMenuId', i)
  },

  // 获得一级菜单ID
  getOneMenuId () {
    let n = this.getCookie('dtcOneMenuId')
    return n
  },

  // 设置二级菜单ID
  setTwoMenuId (i) {
    this.setCookie('dtcTwoMenuId', i)
  },

  // 获得二级菜单ID
  getTwoMenuId () {
    let n = this.getCookie('dtcTwoMenuId')
    return n
  },
  // 获取用户登录权限
  getSysType () {
    let t = this.getCookie('dtcUSysType')
    return t
  },

  // 获得权限列表
  getListMenu () {
    let m = this.getLocalStorage('dtcListMenu')
    return m
  },

  // 设置动态路由列表
  setNewRoute (list) {
    this.setLocalStorage('dtcNewRoute', window.JSON.stringify(list))
  },

  // 获得permissionNo
  getPermissionNo () {
    let i = this.getCookie('dtcPermissionNo')
    return i
  },

  // 获得动态路由列表
  getNewRoute () {
    let l = this.getLocalStorage('dtcNewRoute')
    l && (l = window.JSON.parse(l))
    return l
  },

  /**
   *
   * 设置获得语言类型
   * 中文 (zh-CN)
   * 英文 (en)
   *
   */
  setLanguage (lan) {
    let getLanguge = lan
    let setLanguge = ''
    const getLanType = hostPath.lanType
    if (getLanType === 'en') {
      setLanguge = 'en'
    } else if (getLanType === 'zh-CN') {
      setLanguge = 'zh-CN'
    } else {
      if (!getLanguge) {
        getLanguge = this.getLanguage()
        if (getLanguge) {
          setLanguge = getLanguge
        } else {
          getLanguge = navigator.language
          if (getLanguge === 'zh-CN') {
            setLanguge = 'zh-CN'
          } else if (getLanguge === 'en') {
            setLanguge = 'en'
          } else {
            setLanguge = 'en'
          }
        }
      } else {
        setLanguge = getLanguge
      }
    }
    this.setCookie('dtcLan', setLanguge)
    store.dispatch('getItemSys', { lan: setLanguge })
  },

  getLanguage () {
    let l = this.getCookie('dtcLan')
    return l
  },

  // 当前语言类型是否为英文
  isEnLan () {
    let r = false
    let l = this.getCookie('dtcLan')
    if (l === 'en') {
      r = true
    }
    return r
  },

  isZhCNLan () {
    let r = false
    let l = this.getCookie('dtcLan')
    if (l === 'zh-CN') {
      r = true
    }
    return r
  },

  // 获得登录的用户名
  getUserLUserName () {
    let s = this.getCookie('dtcLUName')
    return s
  },

  // 获得登录的密码
  getUserLSn () {
    let s = this.getCookie('dtcLSn')
    return s
  },

  languageOptions (lan) {
    // 默认为英文
    let r = [
      { value: 'zh-CN', label: '中文' },
      { value: 'en', label: 'English' }
    ]
    // 如果有语言类型传进来,即为获得语言图标
    let img = ''
    if (lan) {
      r.some(v => {
        if (v.value === lan) {
          img = v.img
          return true
        }
      })
      return img
    } else {
      return r
    }
  },

  // 判断数据是否为空
  isEmptyVal (val) {
    if (val === undefined || val === '') {
      return '--'
    } else {
      return val
    }
  },

  // 验证上传的文件类型，是否为pdf
  isPdfType (file) {
    const fileType = file.type
    if (fileType.lastIndexOf('/pdf') > 0) {
      return true
    }
    return false
  },
  // 判断传回的文件是否为PDF
  checkePdf (file) {
    if (file) {
      if (file.indexOf('.pdf') > 0 || file.indexOf('.PDF') > 0) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  // 验证上传的文件类型，是否为png/jpeg/gif等
  isPictureType (file) {
    const fileType = file.type
    if (
      fileType.lastIndexOf('/jpeg') > 0 ||
      fileType.lastIndexOf('/png') > 0 ||
      fileType.lastIndexOf('/x-icon') > 0 ||
      fileType.lastIndexOf('/gif') >= 0
    ) {
      return true
    }
    return false
  },

  // 错误警告提示
  warningInfoTip (info, time) {
    let duration = 2500
    if (time) {
      duration = time
    }
    Message({
      type: 'info',
      message: info,
      duration: duration
    })
    return false
  },

  // 成功提示
  successInfoTip (info, time) {
    let duration = 2500
    if (time) {
      duration = time
    }
    Message({
      type: 'success',
      message: info,
      duration: duration
    })
    return false
  },
  getWeek () {
    let date = new Date()
    let daty = date.getDay()
    const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    return weeks[daty]
  },
  // 格式化时间 年，月，日，时，分，秒
  formatDate (now) {
    if (!now || now === 'null' || now === '--') {
      return ''
    }
    if (now) {
      now = new Date(now)
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      let date = now.getDate()
      let hour = now.getHours()
      let minute = now.getMinutes()
      let second = now.getSeconds()
      if (month < 10) {
        month = `0${month}`
      }
      if (date < 10) {
        date = `0${date}`
      }
      if (hour < 10) {
        hour = `0${hour}`
      }
      if (minute < 10) {
        minute = `0${minute}`
      }
      if (second < 10) {
        second = `0${second}`
      }
      return `${month}/${date}/${year} ${hour}:${minute}:${second}`
    } else {
      return ''
    }
  },

  // 格式化时间方法 无 时、分、秒  type为拼接的方式
  formatDate2 (now, type) {
    now = new Date(now)
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let date = now.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (date < 10) {
      date = '0' + date
    }
    if (type) {
      return year + type + month + type + date
    } else {
      return year + '-' + month + '-' + date
    }
  },

  // 格式化年月日   type: 中国显示方式(ch)及拼接的方式
  // 注: 只有在接口传参时才需要中国的显示方式,其它为美式
  formatYMD (now, type) {
    if (Number(now)) {
      now = Number(now)
    }
    if (!now || now === 'null' || now === '--') {
      return '--'
    }
    if (now) {
      let year = ''
      let month = ''
      let date = ''
      // 这里的8位用于返回如 20180423 这样的格式
      if (
        String(now).length === 8 &&
        String(now).indexOf('-') === -1 &&
        String(now).indexOf('/') === -1
      ) {
        const getNow = String(now)
        return `${getNow.substring(4, 6)}/${getNow.substring(
          6,
          8
        )}/${getNow.substring(0, 4)}`
      } else {
        now = new Date(now)
        year = now.getFullYear()
        month = now.getMonth() + 1
        date = now.getDate()
      }
      if (month < 10) {
        month = `0${month}`
      }
      if (date < 10) {
        date = `0${date}`
      }
      if (type === 'ch') {
        return `${year}-${month}-${date}`
      } else if (type) {
        return `${year}${type}${month}${type}${date}`
      } else {
        return `${month}/${date}/${year}`
      }
    } else {
      return ''
    }
  },

  // 格式化金钱
  formatUSD (val, currency) {
    if (this) {
      if (
        (val === '' || val === '--' || val === undefined || !val) &&
        val !== 0
      ) {
        return '--'
      }
      // 先判断数据是否有小数点
      let newVal = String(val)
      let isHasDis = false
      if (newVal.indexOf('-') !== -1) {
        isHasDis = true
        newVal = newVal.substring(1, newVal.length)
      }
      newVal = Number(newVal).toFixed(2) + ''
      let dotIdx = newVal.lastIndexOf('.')
      let dotVal = '' // 保留小数点后面的数据
      // let dotVal = '.00' // 保留小数点后面的数据
      if (dotIdx >= 0) {
        dotVal = newVal.substring(dotIdx, newVal.length)
        newVal = newVal.slice(0, dotIdx)
      }

      let len = newVal.length
      let arr = []
      let lastIndex = null
      while (len > 0) {
        lastIndex = len
        len -= 3
        arr.unshift(newVal.substring(len, lastIndex))
      }
      val = arr.join(',')

      const sysTypeUnit = hostPath.sysTypeUnit
      let setCurrency = '' // 货币符号
      if (sysTypeUnit === 'bocus') {
        setCurrency = '＄'
      } else if (sysTypeUnit === 'jetco') {
        setCurrency = 'HK＄'
      } else if (sysTypeUnit === 'china') {
        setCurrency = '¥'
      }
      if (isHasDis) {
        newVal = `${setCurrency} -${val}${dotVal}`
      } else {
        newVal = `${setCurrency} ${val}${dotVal}`
      }
      return newVal
    }
  },

  // 格式化金额数字，不包含小数点，金额符等 输入整数
  formatAmount (val) {
    if (val === '' || val === '--' || val === undefined) {
      return ''
    }
    // 先判断数据是否有小数点
    let newVal = String(Number(val))

    let len = newVal.length
    let arr = []
    let lastIndex = null
    while (len > 0) {
      lastIndex = len
      len -= 3
      arr.unshift(newVal.substring(len, lastIndex))
    }
    val = arr.join(',')

    return val
  },

  // 格式化百分号
  formatPenc (val) {
    return `%${val.toFixed(2)}`
  },

  // 字段串，三位三位处理 , type 为1时，则需要格式为金额格式 否则为数字字符串就行
  formatNumber: function (val, type) {
    if (val === '--') {
      return '--'
    }
    let len = String(val).split('.')[0].length
    let num2 = String(val).split('.')[1]
    let arr = []
    let lastIndex = null
    while (len > 0) {
      lastIndex = len
      len -= 3
      arr.unshift(String(val).substring(len, lastIndex))
    }
    val = arr.join(',')
    if (type && type === 1) {
      return `${val}.00`
    } else {
      if (num2) {
        return `${val}.${num2}`
      } else {
        return val
      }
    }
  },

  // 判断页面刷新时是否引入了echart(异步), 等待echart才执行图表加载动作
  isLoadEchart (cb) {
    if (!window.echarts) {
      setTimeout(() => {
        this.isLoadEchart(cb)
      }, 100)
    } else {
      cb && cb()
    }
  },

  // 在对象的拷贝方法中比较困扰的就是深层拷贝，此方法为深层拷贝；
  deepCopy (data) {
    return window.JSON.parse(window.JSON.stringify(data))
  },

  /**
   * 时间单位类型
   */
  dateTypeOptions (s) {
    const obj = {
      'zh-CN': [
        { label: '年', value: 'year' },
        { label: '月', value: 'month' },
        { label: '日', value: 'day' }
      ],
      en: [
        { label: 'Year', value: 'year' },
        { label: 'Month', value: 'month' },
        { label: 'Day', value: 'day' }
      ]
    }
    let lan = this.getLanguage()
    if (!lan) {
      lan = 'en'
    }
    if (s) {
      let o = obj[lan]
      let r = ''
      o.some(v => {
        if (v.value === s) {
          r = v.label
          return true
        }
      })
      return r
    } else {
      return obj[lan]
    }
  },

  // 处理返回操作
  todoBack (query) {
    if (query && query.source) {
      router.push({
        name: query.source,
        params: query
      })
    } else {
      router.back()
    }
  },

  /**
   * 币种
   */
  currencyOptions (s) {
    const obj = {
      'zh-CN': [
        { label: '美元', value: 'USD' },
        { label: '元', value: 'RMB' }
      ],
      en: [
        { label: 'USD', value: 'USD' },
        { label: 'RMB', value: 'RMB' }
      ]
    }
    let lan = this.getLanguage()
    if (!lan) {
      lan = 'en'
    }
    if (s) {
      let o = obj[lan]
      let r = ''
      o.some(v => {
        if (v.value === s) {
          r = v.label
          return true
        }
      })
      return r
    } else {
      return obj[lan]
    }
  },

  // 获取文件完整地址
  getFileUrl (url) {
    let file = `${hostPath.apiUrl}/download/file?filename=`
    return file + url
  },
  // 获取文件完整地址2
  getFileUrlHasNo (name, no, index) {
    let setIndex = 0
    if (index) {
      setIndex = index
    }
    let file = `${hostPath.apiUrl}/download/multiple/file?fileNo=${no}&fileIndex=${setIndex}`
    return file
  },
  // 加密1
  doEncryptTfp (input) {
    let key = CryptoJS.enc.Utf8.parse('lcz66001g0qcd0c3')
    let srcs = CryptoJS.enc.Utf8.parse(input)
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  // 解密1
  doDecryptTfp (input) {
    let key = CryptoJS.enc.Utf8.parse('lcz66001g0qcd0c3')
    let decrypt = CryptoJS.AES.decrypt(input, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7})
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },
  // 加密 aes (crypto-js)
  doEncrypt (input, k) {
    let setKey =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    if (k) {
      setKey = k
    }

    var output = ''
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    input = this._utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output =
        output +
        setKey.charAt(enc1) +
        setKey.charAt(enc2) +
        setKey.charAt(enc3) +
        setKey.charAt(enc4)
    }
    return output
  },
  // 解密
  doDecrypt (input, k) {
    let setKey =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    if (k) {
      setKey = k
    }
    var output = ''
    var chr1, chr2, chr3
    var enc1, enc2, enc3, enc4
    var i = 0
    input = input.replace(/[^A-Za-z0-9\\+\\/\\=]/g, '')
    while (i < input.length) {
      enc1 = setKey.indexOf(input.charAt(i++))
      enc2 = setKey.indexOf(input.charAt(i++))
      enc3 = setKey.indexOf(input.charAt(i++))
      enc4 = setKey.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3)
      }
    }
    output = this._utf8_decode(output)
    return output
  },
  // private method for UTF-8 encoding
  _utf8_encode (string) {
    string = string.replace(/\r\n/g, '\n')
    var utftext = ''
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },

  // private method for UTF-8 decoding
  _utf8_decode (utftext) {
    var string = ''
    var i = 0
    var c = 0
    var c2 = 0
    var c3 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        )
        i += 3
      }
    }
    return string
  },
  // a标签跳转
  windowOpen (url) {
    if (url) {
      if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
        const contentType = url.substring(5, url.indexOf(';base64'))
        const b64Data = url.substring(url.indexOf(',') + 1)
        const byteCharacters = atob(b64Data)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: contentType })
        const u = window.URL.createObjectURL(blob)
        window.open(u)
      } else {
        const loadTips = Loading.service()
        axios({
          method: 'get',
          url: url,
          responseType: 'blob'
        }).then(res => {
          if (res && res.data && res.data.size) {
            const dataInfo = res.data
            let reader = new window.FileReader()
            reader.readAsDataURL(dataInfo)
            reader.onload = function (e) {
              const result = e.target.result
              const contentType = dataInfo.type
              const b64Data = result.substring(result.indexOf(',') + 1)
              const byteCharacters = atob(b64Data)
              const byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              const byteArray = new Uint8Array(byteNumbers)
              const blob = new Blob([byteArray], { type: contentType })
              const u = window.URL.createObjectURL(blob)
              window.open(u)
            }
          }
          loadTips.close()
        })
      }
    }
  },
  // form表单保存失败时，滚动条滚动到第一个报错的地方
  // $VM: 当前实例对象， formName:form表单name
  validFormFailPositionToFirstProp ($VM, formName, el) {
    // 遍历form对象下面所有要检验的字段
    $VM.$refs[formName].$data.fields.some(v => {
      if (v.validateState === 'error') {
        this.gotoPosition(v.$el, el)
        return true
      }
    })
  },

  // 跳转到相应的的位置 obj 为id或class, body里容器的滚动,需要给马滚动的对象(class/id)传进入
  gotoPosition (obj, el) {
    if ($(obj).offset()) {
      if (el) {
        let top = $(obj).offset().top - 150
        if (top < 0) {
          top = 0
        }
        $(el).scrollTop(top)
      } else {
        let top = $(obj).offset().top - 150
        if (top < 0) {
          top = 0
        }
        $('html,body').animate({ scrollTop: top }, 300)
      }
    }
  },

  // 文件名称处理,返回对应的ICON样式
  checkFileType (name) {
    let className = ''
    if (name) {
      const newName = name.toLocaleLowerCase()
      if (newName.toLocaleLowerCase().indexOf('.csv') !== -1) {
        className = 'com_icon_csv'
      } else if (newName.indexOf('.doc') !== -1) {
        className = 'com_icon_doc'
      } else if (newName.indexOf('.xls') !== -1) {
        className = 'com_icon_xls'
      } else if (
        newName.indexOf('.jpg') !== -1 ||
        name.indexOf('.jpeg') !== -1
      ) {
        className = 'com_icon_jpg'
      } else if (newName.indexOf('.png') !== -1) {
        className = 'com_icon_png'
      } else if (newName.indexOf('.pdf') !== -1) {
        className = 'com_icon_pdf'
      } else if (newName.indexOf('.zip') !== -1) {
        className = 'com_icon_zip'
      } else if (newName.indexOf('.rar') !== -1) {
        className = 'com_icon_rar'
      }
    }
    return className
  },

  // 使用form表单提交数据导出表格
  downloadExcel (url, method = 'post', downloadFileName, params = {}) {
    const loadTips = Loading.service()
    let obj = {
      method: method,
      url: url,
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }

    if (method === 'post') {
      obj.data = params
    }
    if (method === 'get') {
      obj.params = params
    }
    axios(obj).then(res => {
      loadTips.close()
      if (res && res.data) {
        var reader = new window.FileReader()
        reader.readAsDataURL(res.data)
        reader.onload = function (e) {
          const result = e.target.result
          var a = document.createElement('a')
          let fileName = 'download'
          const headFileName = res.headers['content-disposition']
          if (headFileName) {
            fileName = headFileName.split('filename=')[1]
          } else if (res.data.type === 'application/vnd.ms-excel') {
            fileName = 'download.xls'
            downloadFileName && (fileName = `${downloadFileName}.xls`)
          }
          a.download = fileName
          a.href = result
          $('body').append(a) // 修复firefox中无法触发click
          a.click()
          $(a).remove()
        }
      }
    })
  },
  // 使用a标签打开新连接
  newWindowOpen (url, fileName) {
    const elink = document.createElement('a')
    fileName && (elink.download = fileName)
    elink.style.display = 'none'
    elink.href = url
    elink.target = '_blank'
    document.body.appendChild(elink)
    elink.click()
  },
  /**
   * 返回内容为base64的下载
   * @param sendUrl 请求下载地址
   * @param sendData 请求参数
   * @param downloadName 文件名
   */
  getBase64File (sendUrl, sendData, downloadName, method = 'get', headers = {}) {
    const loadTips = Loading.service()
    const axiosOpt = {
      method,
      url: sendUrl,
      responseType: 'blob'
    }
    if (method === 'post') {
      axiosOpt.data = sendData
    }
    if (method === 'get') {
      axiosOpt.params = sendData
    }
    if (Object.keys(headers).length > 0) axiosOpt.headers = headers
    axios(axiosOpt)
      .then(res => {
        if (res && res.data && res.data.size) {
          const dataInfo = res.data
          const blob = new Blob([dataInfo], { type: dataInfo.type })
          const u = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = u
          let setDownloadName = 'download'
          const headFileName = res.headers['content-disposition']
          if (headFileName) {
            downloadName = `${headFileName.split('filename=')[1]}`
          }
          downloadName && (setDownloadName = downloadName)
          a.download = setDownloadName
          a.click()
          window.URL.revokeObjectURL(u)
        } else {
          this.warningInfoTip('Load Failure')
        }
        loadTips.close()
      })
      .catch(() => {
        loadTips.close()
      })
  },
  /**
   * 处理文件名,文件路径处理
   * @param no 文件编号
   * @param index 单个对象中有多个文件时的索引值
   * @returns {string}
   */
  checkFileName (name, no, index, cb) {
    let fileNo = no
    let fileIndex = index
    if (!index) {
      fileIndex = 0
    }
    if (name) {
      if (name.indexOf('http://') !== 0 && name.indexOf('https://') !== 0) {
        if (name.indexOf('.pdf') !== -1 || name.indexOf('.PDF') !== -1) {
          const result = `${hostPath.apiUrl}${
            apiPath.common.downloaddUrl
          }?fileNo=${fileNo}&fileIndex=${fileIndex}&userId=${this.getUserId()}`
          if (cb) {
            cb(result)
          } else {
            return result
          }
        } else {
          const loadTips = Loading.service()
          axios({
            method: 'get',
            url: apiPath.common.downloaddUrl,
            params: {
              fileNo: fileNo,
              fileIndex: fileIndex
            },
            responseType: 'blob'
          }).then(res => {
            if (res && res.data && res.data.size) {
              const dataInfo = res.data
              let reader = new FileReader()
              reader.readAsDataURL(dataInfo)
              reader.onload = function (e) {
                const result = e.target.result
                // 执行回调函数
                cb && cb(result)
              }
            }
            loadTips.close()
          })
        }
      } else {
        if (cb) {
          cb(name)
        } else {
          return name
        }
      }
    }
  },
  /**
   * 头部Token
   */
  headers () {
    const obj = { token: this.getToken(), userId: this.getUserId() }
    return obj
  },

  /**
   * 四级导航的显示处理
   *
   */
  getCurFourMenu (pId, list) {
    let arr = []
    list.forEach(v => {
      if (v.menuLevel === 4 && v.parentMenuId === pId) {
        arr.push(v)
      }
    })
    return arr
  },
  /**
   * 四级导航的显示处理
   *
   */
  isShowItem (key, list) {
    let r = false
    list.some(v => {
      if (v.description === key) {
        r = true
        return true
      }
    })
    return r
  },
  orderStatus (value) {
    let status = [
      {
        lable: 'Unshipped', value: '未出库、未发货'
      },
      {
        lable: 'Pending', value: '已付款未授权'
      },
      {
        lable: 'Shipped', value: '已出库、已发货'
      },
      {
        lable: 'Shipping', value: '发货中'
      },
      {
        lable: 'Complete', value: '已完成'
      },
      {
        lable: 'Cancelled', value: '取消下单'
      },
      {
        lable: 'On Trial', value: '审核中'
      },
      {
        lable: 'PartiallyShipped', value: '部分出库'
      },
      {
        lable: 'WFD', value: '等待发货'
      },
      {
        lable: 'WFD', value: '等待发货'
      },
      {
        lable: 'WFA', value: '等待审核'
      },
      {
        lable: 'AOOS', value: '已出库'
      },
      {
        lable: 'AS', value: '下单完成'
      },
      {
        lable: 'DF', value: '下单失败'
      },
      {
        lable: 'CO', value: '取消下单'
      },
      {
        lable: 'OD', value: '超时未发货'
      }
    ]
    let str = ''
    status.some(item => {
      if (item.lable === value) {
        str = item.value
      }
    })
    return str
  },
  showDailg (response, type) {
    console.log(response)
    console.log(type)
    let setTips = this.isEnLan() ? 'Confirm' : '确认'
    let setTips2 = this.isEnLan() ? 'Cancel' : '取消'
    var showInfo = ''
    if (type === 0) {
      if (response.data.errorCode === '-100' || response.data.status === -108 || response.data.status === -1) {
        if (this.isEnLan()) {
          if (response.data.errorMsg) {
            showInfo = response.data.errorMsg
          } else {
            showInfo = response.data.errorMsg
          }
        } else {
          showInfo = response.data.errorMsg
        }
        MessageBox.alert(showInfo, '', {
          confirmButtonText: setTips,
          cancelButtonText: setTips2,
          type: 'warning'
        })
          .then(() => {
            location.href = '/'
          })
          .catch(() => {})
      } else {
        this.warningInfoTip(showInfo)
      }
    } else {
      if (this.isEnLan()) {
        if (response.errorInfoEn) {
          showInfo = response.errorMsg
        } else {
          showInfo = response.errorMsg
        }
      } else {
        showInfo = response.errorMsg
      }

      // common.warningInfoTip(showInfo)
      // location.href = "/"
      if (response.status === -100 || response.status === -108) {
        MessageBox.alert(showInfo, '', {
          confirmButtonText: setTips,
          cancelButtonText: setTips2,
          type: 'warning'
        })
          .then(() => {
            location.href = '/'
          })
          .catch(() => {})
      } else {
        this.warningInfoTip(showInfo)
      }
    }
  },

  /**
   * 获得日期
   * @param {Object} day 当天传0（默认为0） 昨天传 1
   */
  getDay (day = 0) {
    let getDate = new Date()
    getDate.setTime(getDate.getTime() - 24 * 60 * 60 * 1000 * day)
    const setMoth = this.checkZero(getDate.getMonth() + 1)
    const setDate = this.checkZero(getDate.getDate())
    const dayStr = `${getDate.getFullYear()}-${setMoth}-${setDate}`
    return dayStr
  },
  /**
   * 获得去年的今天
   * @param {Object}
   */
  getPreYearCurDay () {
    let getDate = new Date()
    const setMoth = this.checkZero(getDate.getMonth() + 1)
    const setDate = this.checkZero(getDate.getDate())
    return `${getDate.getFullYear() - 1}-${setMoth}-${setDate}`
  },
  // 日期补0处理
  checkZero (val) {
    let setVal = val
    setVal < 10 && (setVal = '0' + setVal)
    return setVal
  },
  // 快捷时间入口
  dayFastOptions (s) {
    const obj = {
      'zh-CN': [
        { label: '最近7天', value: 7 },
        { label: '最近30天', value: 30 },
        { label: '最近1年', value: 365 }
      ],
      en: [
        { label: '最近7天', value: 7 },
        { label: '最近30天', value: 30 },
        { label: '最近1年', value: 365 }
      ]
    }
    let lan = this.getLanguage()
    return obj[lan]
  },
  /**
   * 获得经纬度
   * longitude 经度
   * latitude 纬度
   * */
  getLonLat (id) {
    // let getRegionData = this.getAllRegionData()
    let getId = Number(id)
    let obj = []
    regionData && regionData.length && regionData.some(item => {
      if (getId === item.did) {
        obj = []
        obj.push(item.longitude)
        obj.push(item.latitude)
        return true
      }
    })
    return obj
  }
  // // 缓存所有地区数据
  // getAllRegionData () {
  //   // const regionData = sessionStorage.getItem('bigdata_regionData')
  //   return new Promise((resolve, reject) => {
  //     if (regionData) {
  //       resolve(JSON.parse(regionData))
  //     } else {
  //       if (!this.loadingRegion) {
  //         this.loadingRegion = true
  //         axios({
  //           method: 'get',
  //           url: apiPath.common.allArea
  //         }).then(res => {
  //           const resData = res.data
  //           this.loadingRegion = false
  //           if (res && resData) {
  //             sessionStorage.setItem('bigdata_regionData', JSON.stringify(resData))
  //             resolve(resData)
  //           }
  //         })
  //       } else {
  //         const Interval = setInterval(() => {
  //           const regionData = sessionStorage.getItem('bigdata_regionData')
  //           if (regionData) {
  //             resolve(JSON.parse(regionData))
  //             clearInterval(Interval)
  //           }
  //         }, 1000)
  //       }
  //     }
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/utils/common.js